import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import items from "../images/items.png";
import add from "../images/additem.png";
import remove from "../images/removeitems.png";
import summary from "../images/summary.png";
import bills from "../images/bill-white.png";
import notifications from "../images/notification-white.png";
import purchase from "../images/purchase-white.png";
import counterpart from "counterpart";
import eng from "../lang/eng";
import urdu from "../lang/urdu";
import { Box, Typography } from "@mui/material";
import { getItems } from "./inventory/itemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCompany } from "./company profile/companySlice";
import { getUser } from "../pages/userSlice";
import Repo from "../Repository/Repo";
import { Toast } from "./components/Toast";
counterpart.registerTranslations("eng", eng);
counterpart.registerTranslations("urdu", urdu);

counterpart.setLocale("eng");

// class Cards extends Component {
//   componentWillMount() {
//     counterpart.setLocale(this.props.lang);
//   }

//   render() {
// const companyCode = localStorage.getItem("companyCode");
// if (
//   localStorage.getItem("token") == null ||
//   localStorage.getItem("tokenType") != "admin"
// ) {
//   window.location.reload();
// }
const Cards = ({ lang }) => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);
  const [deactivated, setDeactivated] = useState(false);
  console.log("Deactivated", deactivated);

  useEffect(() => {
    counterpart.setLocale(lang);
  }, [lang]);

  useEffect(() => {
    //convert unix timestamp to date
    if (!deactivated && user?.nextPaymentDate) {
      const unixTimestamp = user?.nextPaymentDate;
      const milliseconds = unixTimestamp * 1000; // 1575909015000
      const dateObject = new Date(milliseconds);
      console.log("Date Object", dateObject);
      const currentDate = new Date();
      console.log("Current Date", currentDate);

      // if (dateObject < currentDate && user?.limitations) {
      if (dateObject < currentDate) {
        handleDeactivateUserAccount().then(() => {
          setDeactivated(true); // Mark as executed
          dispatch(getUser());
        });
      }
    }
  }, [user, deactivated, dispatch]);

  const handleDeactivateUserAccount = async () => {
    let info = {
      email: localStorage.getItem("email"),
    };

    try {
      const response = await Repo.user({
        request: {
          method: "deactivateUserAccount",
          data: info,
        },
      });

      console.log("Deactivate Response", response);

      if (response.data.response.status.statusCode === 200) {
        Toast("success", "Account Deactivated");

        setTimeout(() => {
          localStorage.clear(); // Clear all localStorage data
          window.location.href = "/inventory/login"; // Reload the page and navigate to login
        }, 1500); // Allow time for the Toast message
      }
    } catch (error) {
      console.error("Error during account deactivation", error);
      // Toast("error", "Failed to deactivate account");
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("tokenType") !== "admin"
    ) {
      window.location.reload();
    }
    dispatch(getItems());
    dispatch(getCompany());
  }, []);

  const companyCode = localStorage.getItem("companyCode");
  return (
    <div className="center">
      <Box className="Title" sx={{ mt: { md: "0px", xs: "56px" } }}>
        <Typography variant="h1">
          WELCOME TO {localStorage.getItem("company").toUpperCase()}
        </Typography>
        <h2>CEO PANEL</h2>
      </Box>

      {companyCode != 4416 && (
        <div className="cards">
          <Link to="/inventory/admin/outgoing">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={remove} alt="remove-img"></img>
              <h2 className="btntext">Sale</h2>
            </button>
          </Link>

          <Link className="Link" to="/inventory/admin/items">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={items} alt="items-img"></img>
              <h2 className="btntext">Items</h2>
            </button>
          </Link>

          <Link to="/inventory/admin/summary">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={summary} alt="summary-img"></img>
              <h2 className="btntext">Summary</h2>
            </button>
          </Link>

          <Link to="/inventory/admin/bills">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={bills} alt="remove-img"></img>
              <h2 className="btntext">Bills</h2>
            </button>
          </Link>

          <Link className="Link" to="/inventory/admin/notifications">
            <button variant="contained" color="primary" className="card">
              <img
                className="imgicon"
                src={notifications}
                alt="items-img"
              ></img>
              <h2 className="btntext">Notifications</h2>
            </button>
          </Link>

          <Link to="/inventory/admin/purchase-order">
            <button variant="contained" color="primary" className="card">
              <img className="imgicon" src={purchase} alt="summary-img"></img>
              <h2 className="btntext">Purchase</h2>
            </button>
          </Link>
        </div>
      )}
    </div>
  );
};
export { Cards };
